'use client';

import { useEffect, useRef, useState } from 'react';

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  className?: string;
  options: DropdownOption[];
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  pickMode?: boolean;
}

export default function Dropdown({ className, options, value, placeholder, onChange, disabled, pickMode, }: DropdownProps) {
  const [open, setOpen,] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onPointerDown(e: PointerEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener(`pointerdown`, onPointerDown);
    return () => document.removeEventListener(`pointerdown`, onPointerDown);
  }, []);

  const selected = !pickMode && value ? options.find(o => o.value === value) : null;
  const label = selected?.label ?? placeholder ?? ``;

  return (
    <div ref={ref} className={`dropdown-component${disabled ? ` disabled` : ``}${open ? ` open` : ``}${className ? ` ${className}` : ``}`}>
      <button
        className="dropdown-trigger"
        onPointerDown={e => { e.preventDefault(); setOpen(o => !o); }}
        type="button"
      >
        <span className="dropdown-label">{label}</span>
        <span className="dropdown-chevron">▾</span>
      </button>
      {open && (
        <div className="dropdown-list">
          {options.map(o => (
            <button
              key={o.value}
              className={`dropdown-option${!pickMode && value === o.value ? ` selected` : ``}`}
              onClick={() => { onChange(o.value); setOpen(false); }}
              type="button"
            >
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
